export default "__VITE_ASSET__76027936__"